export default __webpack_public_path__ + "static/media/WomenbizPH-black.8a754266.png";